import { useDictStore } from "@/stores/dictStore";
import { DeliveryWeightItem } from "../../entities/delivery";
import { Partition } from "../../entities/partition";
import { Door } from "../../entities/door";
import { Overdoor } from "../../entities/overdoor";
import { CreateOneStrategy } from "../base/creation.strategy";
import { Pricing } from "../../entities/pricing";

export class DeliveryDividerCreationStrategy extends CreateOneStrategy {
    constructor(
        divider: Partition,
        isSteel: boolean,
        unit: string,
    ) {

        const dicts = useDictStore();

        const glassType = divider.getActiveGlassThinkness()?.structureType;
        const glassInfo = dicts.findGlassWeight(glassType, isSteel, unit)
        const dividerArea = divider.dimensions.getAreaFt().toSquareFt().formatSq();

        const weightPerSqFt = glassInfo?.sum || 0;
        const dividerWeight = +dividerArea * weightPerSqFt;

        const glassWeightPerSqFt = glassInfo?.glass_weight || 0;
        const glassWeight = +dividerArea * glassWeightPerSqFt;

        const deliveryElementConfig = {
            qty: dividerArea,
            glass_weight: +glassWeight.toFixed(2),
            price: new Pricing(
                weightPerSqFt,
                weightPerSqFt,
                weightPerSqFt,
            ),
            sum: new Pricing(
                dividerWeight,
                dividerWeight,
                dividerWeight,
            ),
        };

        super(deliveryElementConfig, DeliveryWeightItem);
    }
}

export class DeliveryGlassPartitionCreationStrategy extends CreateOneStrategy {
    constructor(
        glassPartition: Partition,
        isSteel: boolean,
        unit: string,
    ) {
        const dicts = useDictStore();

        const glassType = glassPartition.getActiveGlassThinkness()?.structureType;
        const glassInfo = dicts.findGlassWeight(glassType, isSteel, unit)
        const glassPartitionArea = glassPartition.getPartitionSquareWithoutDoorsAndOverdoors();

        const weightPerSqFt = glassInfo?.sum || 0;
        const glassPartitionWeight = +glassPartitionArea * weightPerSqFt;

        const glassWeightPerSqFt = glassInfo?.glass_weight || 0;
        const glassWeight = +glassPartitionArea * glassWeightPerSqFt;

        const deliveryElementConfig = {
            qty: glassPartitionArea,
            glass_weight: +glassWeight.toFixed(2),
            price: new Pricing(
                weightPerSqFt,
                weightPerSqFt,
                weightPerSqFt,
            ),
            sum: new Pricing(
                glassPartitionWeight,
                glassPartitionWeight,
                glassPartitionWeight,
            ),
        };

        super(deliveryElementConfig, DeliveryWeightItem);
    }
}

export class DeliveryDoorCreationStrategy extends CreateOneStrategy {
    constructor(
        door: Door,
        isSteel: boolean,
        unit: string,
    ) {
        const dicts = useDictStore();

        const glassType = door.getActiveGlassThinkness()?.structureType;
        const glassInfo = dicts.findGlassWeight(glassType, isSteel, unit)
        const doorArea = door.dimensions.getAreaFt().toSquareFt().formatSq();

        const weightPerSqFt = glassInfo?.sum || 0;
        const doorWeight = +doorArea * weightPerSqFt;

        const glassWeightPerSqFt = glassInfo?.glass_weight || 0;
        const glassWeight = +doorArea * glassWeightPerSqFt;

        const deliveryElementConfig = {
            qty: doorArea,
            glass_weight: +glassWeight.toFixed(2),
            price: new Pricing(
                weightPerSqFt,
                weightPerSqFt,
                weightPerSqFt,
            ),
            sum: new Pricing(
                doorWeight,
                doorWeight,
                doorWeight,
            ),
        };

        super(deliveryElementConfig, DeliveryWeightItem);
    }
}

export class DeliveryOverdoorCreationStrategy extends CreateOneStrategy {
    constructor(
        overdoor: Overdoor,
        isSteel: boolean,
        unit: string,
    ) {
        const dicts = useDictStore();

        const glassType = overdoor.getGlassThinkness()?.structureType;
        console.log("glassType", glassType)
        const glassInfo = dicts.findGlassWeight(glassType, isSteel, unit)
        const overdoorArea = overdoor.dimensions.getAreaFt().toSquareFt().formatSq();

        const weightPerSqFt = glassInfo?.sum || 0;
        const overdoorWeight = +overdoorArea * weightPerSqFt;

        const glassWeightPerSqFt = glassInfo?.glass_weight || 0;
        const overdoorGlassArea = overdoor?.isGlassOverdoor() ? +overdoorArea : 0;
        const glassWeight = overdoorGlassArea * glassWeightPerSqFt;

        const deliveryElementConfig = {
            qty: overdoorArea,
            glass_weight: +glassWeight.toFixed(2),
            price: new Pricing(
                weightPerSqFt,
                weightPerSqFt,
                weightPerSqFt,
            ),
            sum: new Pricing(
                overdoorWeight,
                overdoorWeight,
                overdoorWeight,
            ),
        };

        super(deliveryElementConfig, DeliveryWeightItem);
    }
}
